import { Accordion } from '../jdsaccordionlist/generated';
import { AccordionPanel } from '../jdsaccordion/generated';
import { FooterLinks } from '../jdsfooterlinks/generated';
import { FooterProps } from './interface';

const FooterAccordion = (props: { links: FooterProps['links'] }) => {
  return (
    <Accordion allowMultiple>
      {props.links?.map((link) => (
        <AccordionPanel key={link.title} header={link.title}>
          <FooterLinks links={link.subLinks} />
        </AccordionPanel>
      ))}
    </Accordion>
  );
};

export { FooterAccordion };
